/* eslint-disable no-debugger */
import { put, takeLatest, call, all } from "redux-saga/effects";
import {
  addBranchDetailsFailure,
  addBranchDetailsSuccess,
  addBranchDetailsResponseChanged,
  updateBranchDetailsFailure,
  updateBranchDetailsSuccess,
  updateBranchDetailsResponseChanged,
  getBranchListFailure,
  getBranchListSuccess,
  getBranchListResponseChanged,
  fetchBranchDetailsFailure,
  fetchBranchDetailsSuccess,
  fetchBranchDetailsResponseChanged,
  deleteBranchDetailsFailure,
  deleteBranchDetailsSuccess,
  deleteBranchDetailsResponseChanged,
} from "./branch.action";
import BranchActionTypes from "./branch.types";
import { encryptData } from "../../_common/enode-decode";
import {
  branchDetailsAdd,
  branchDetailsDelete,
  branchGetData,
  branchDetailsUpdate,
  branchListGet,
} from "./branch.services";

/** ***************** ADD BRANCH DETAILS START *********************** */
export function* addBranchDetails({ payload }: any) {
  const {
    branchName,
    address1,
    address2,
    city,
    state,
    country,
    zipcode,
    CompanyID,
    UserID,
    UserName,
    InstanceName,
  } = payload;
  try {
    const key = "CreateBranchKey";
    const jsonData = {
      BranchName: branchName,
      Address1: address1,
      Address2: address2,
      City: city,
      State: state,
      Country: country,
      Zipcode: zipcode,
      IsHeadOffice: payload.isHeadOffice === false ? "0" : "1",
      CompanyID: CompanyID,
      CreatedBy: UserID,
      UserName: UserName,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(branchDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addBranchDetailsFailure(responseData.data));
    } else {
      yield put(addBranchDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addBranchDetailsFailure(error));
  }
}

export function* resetAddBranchResponse() {
  yield put(addBranchDetailsResponseChanged());
}

export function* onAddBranchDetails() {
  yield takeLatest(
    BranchActionTypes.ADD_BRANCH_DETAILS_START,
    addBranchDetails,
  );
}

export function* onAddBranchDetailsResponseReset() {
  yield takeLatest(
    BranchActionTypes.ADD_BRANCH_DETAILS_RESPONSE_RESET,
    resetAddBranchResponse,
  );
}
/** ***************** ADD BRANCH DETAILS END *********************** */

/** *********************  START UPDATE BRANCH DETAILS  ******************** */
export function* updateBranchDetails({ payload }: any) {
  const {
    branchName,
    address1,
    address2,
    city,
    state,
    country,
    zipcode,
    CompanyID,
    isHeadOffice,
    UserID,
    branchID,
    UserName,
    oldBranch,
    InstanceName,
  } = payload;
  try {
    const key = "UpdateBranchKey";
    const jsonData = {
      BranchName: branchName,
      Address1: address1,
      Address2: address2,
      City: city,
      State: state,
      Country: country,
      Zipcode: zipcode,
      IsHeadOffice: isHeadOffice === false ? "0" : "1",
      CompanyID: CompanyID,
      UpdatedBy: UserID,
      BranchID: branchID,
      UserName: UserName,
      OldBranchName: oldBranch,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(branchDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateBranchDetailsFailure(responseData.data));
    } else {
      yield put(updateBranchDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateBranchDetailsFailure(error));
  }
}

export function* resetUpdateBranchDetailsResponse() {
  yield put(updateBranchDetailsResponseChanged());
}

export function* onUpdateBranchDetails() {
  yield takeLatest(
    BranchActionTypes.UPDATE_BRANCH_DETAILS_START,
    updateBranchDetails,
  );
}

export function* onUpdateBranchResponseReset() {
  yield takeLatest(
    BranchActionTypes.UPDATE_BRANCH_DETAILS_RESPONSE_RESET,
    resetUpdateBranchDetailsResponse,
  );
}
/** *********************  END UPDATE BRANCH DETAILS ******************** */

/** *********************  START GET BRANCH LIST  ******************** */
export function* getBranchDataOnly({ payload }: any) {
  const { branchID, CompanyID, InstanceName } = payload;
  try {
    const key = "GetBranchKey";
    const jsonData = {
      BranchID: branchID,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(branchGetData, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getBranchListFailure(responseData.data));
    } else {
      yield put(getBranchListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getBranchListFailure(error));
  }
}

export function* resetGetBranchListResponse() {
  yield put(getBranchListResponseChanged());
}

export function* onGetBranchListDetails() {
  yield takeLatest(BranchActionTypes.GET_BRANCH_LIST_START, getBranchDataOnly);
}

export function* onGetBranchListResponseReset() {
  yield takeLatest(
    BranchActionTypes.GET_BRANCH_LIST_RESPONSE_RESET,
    resetGetBranchListResponse,
  );
}
/** *********************  END GET BRANCH LIST ******************** */

/** *********************  START FETCH BRANCH DETAILS  ******************** */
export function* fetchBranchDetails({ payload }: any) {
  const { CompanyID, Limit, searchValueSet, InstanceName } = payload;
  try {
    const key = "GetAllBranchPaginationKey";
    const jsonData = {
      CompanyID: CompanyID,
      Limit: Limit,
      InputSearch: searchValueSet,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(branchListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchBranchDetailsFailure(responseData.data));
    } else {
      yield put(fetchBranchDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchBranchDetailsFailure(error));
  }
}

export function* resetFetchBranchDetailsResponse() {
  yield put(fetchBranchDetailsResponseChanged());
}

export function* onFetchBranchDetails() {
  yield takeLatest(
    BranchActionTypes.FETCH_BRANCH_DETAILS_START,
    fetchBranchDetails,
  );
}

export function* onFetchBranchDetailsResponseReset() {
  yield takeLatest(
    BranchActionTypes.FETCH_BRANCH_DETAILS_RESPONSE_RESET,
    resetFetchBranchDetailsResponse,
  );
}
/** *********************  END FETCH BRANCH DETAILS ******************** */

/** *********************  START DELETE BRANCH DETAILS  ******************** */
export function* deleteBranch({ payload }: any) {
  const { branchID, branchName, UserName, CompanyID, UserID, InstanceName } =
    payload;
  try {
    const key = "DeleteBranchKey";
    const jsonData = {
      BranchID: branchID,
      BranchName: branchName,
      UserName: UserName,
      CompanyID: CompanyID,
      DeletedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(branchDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteBranchDetailsFailure(responseData.data));
    } else {
      yield put(deleteBranchDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteBranchDetailsFailure(error));
  }
}

export function* resetDeleteBranchDetailsResponse() {
  yield put(deleteBranchDetailsResponseChanged());
}

export function* onDeleteBranchDetails() {
  yield takeLatest(BranchActionTypes.DELETE_BRANCH_DETAILS_START, deleteBranch);
}

export function* onDeleteBranchDetailsResponseReset() {
  yield takeLatest(
    BranchActionTypes.DELETE_BRANCH_DETAILS_RESPONSE_RESET,
    resetDeleteBranchDetailsResponse,
  );
}
/** *********************  END DELETE BRANCH DETAILS ******************** */

export function* branchMasterSaga() {
  yield all([
    call(onAddBranchDetails),
    call(onAddBranchDetailsResponseReset),
    call(onUpdateBranchDetails),
    call(onUpdateBranchResponseReset),
    call(onGetBranchListDetails),
    call(onGetBranchListResponseReset),
    call(onFetchBranchDetails),
    call(onFetchBranchDetailsResponseReset),
    call(onDeleteBranchDetails),
    call(onDeleteBranchDetailsResponseReset),
  ]);
}
